<template>
  <div>
    <v-card style="border-radius: 20px">
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-spacer></v-spacer>
          <v-stepper-step :complete="e1 > 1" step="1">Location</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2">Arrival Date</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3">Departure Date</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">Privacy</v-stepper-step>
          <v-btn icon small top right fab @click="$store.commit('closeOnboardingDialog')"><v-icon>mdi-close</v-icon></v-btn>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="onboardingDialogCard" elevation="0">
              <v-card-subtitle class="onboardingDialogSubtitle">First thing's first,</v-card-subtitle>
              <v-card-title style="padding-top: 0">Where are you?</v-card-title>
              <gmap-autocomplete class="placeAutoComplete" :key="autocompleteKey" @place_changed="initMarker" placeholder="Choose Location" :types="['(regions)']" :value="existingPlace?.formatted_address"></gmap-autocomplete>
            </v-card>
            <v-btn class="onboardingBtn" color="primary" @click="getNomadCount()">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="onboardingDialogCard" elevation="0" style="margin-bottom: 0">
              <v-card-subtitle v-if="locationNomadCount" class="onboardingDialogSubtitle">Great! We have {{ locationNomadCount }} Nomads there right now!</v-card-subtitle>
              <v-card-subtitle v-else class="onboardingDialogSubtitle">That's a Great Place to be!</v-card-subtitle>
              <v-card-title style="padding-top: 0">When did you arrive?</v-card-title>
            </v-card>
            <v-date-picker v-model="arrivalDate" scrollable no-title></v-date-picker>
            <v-btn class="onboardingBtn" smaller color="primary" @click="e1 = 1">Back</v-btn>
            <v-btn class="onboardingBtn" smaller color="primary" @click="e1 = 3">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="onboardingDialogCard" elevation="0" style="margin-bottom: 0">
              <v-card-subtitle class="onboardingDialogSubtitle">And if you are of the planned type,</v-card-subtitle>
              <v-card-title style="padding-top: 0">When Are You Leaving?</v-card-title>
            </v-card>
            <v-date-picker v-model="departureDate" scrollable no-title :min="arrivalDate"></v-date-picker>
            <v-btn class="onboardingBtn" color="primary" @click="e1 = 2">Back</v-btn>
            <v-btn class="onboardingBtn" color="primary" @click="e1 = 4">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="onboardingDialogCard" elevation="0" style="margin-bottom: 0">
              <v-card-title style="padding-top: 0">Don't Be Shy</v-card-title>
              <v-card-subtitle v-if="isPublicStay" class="onboardingDialogSubtitle">Other People Will See You're Here</v-card-subtitle>
              <v-card-subtitle v-else class="onboardingDialogSubtitle">Other People Won't See You're Here</v-card-subtitle>
              <div style="display: flex; justify-content: center">
                <v-checkbox class="closeTop" v-model="isPublicStay" on-icon="mdi-eye" off-icon="mdi-eye-off"></v-checkbox>
              </div>
            </v-card>
            <v-btn class="onboardingBtn" color="primary" @click="e1 = 3">Back</v-btn>
            <v-btn class="onboardingBtn" color="primary" @click="addStay">Done</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
    <v-alert transition="scroll-y-transition" dismissible v-model="missingDataAlert" type="error" dense origin="top" border="right" style="position: fixed; top: 5vh">
      Location or Arrival date are Missing
    </v-alert>

  </div>

</template>

<script>

import {allMixins} from "@/mixins/allMixins";
import {store} from "@/store";
/*
import {Client} from "@googlemaps/google-maps-services-js";
*/
import axios from "axios";
import supabase from "@/lib/supabaseClient";
import ViewportControlMixin from '@/mixins/ViewportControlMixin';


export default {
  name: "Onboarding",
  mixins: [allMixins, ViewportControlMixin],
  data() {
    return {
      e1: 1,
      autocompleteKey: 0,
      arrivalDate: null,
      departureDate: null,
      stayDates: [this.arrivalDate, this.departureDate],
      arrivalDateManu: false,
      departureDateManu: false,
      isPublicStay: store.state.userData?.privacyDefault || true,
      existingPlace: null,
      missingDataAlert: false,
      locationNomadCount: null,
    }
  },
  computed: {
    dateRangeText () {
      return this.stayDates.join(' ~ ')
    },
  },
  async mounted() {
    await this.getGeoLocation()
  },
  methods: {
    async getGeoLocation() {
      const axiosInstance = axios.create();

      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
        const { latitude, longitude } = position.coords;

        // Call the Netlify function
        const netlifyFunctionURL = `/.netlify/functions/geocode?lat=${latitude}&lng=${longitude}`;

        const response = await axiosInstance.get(netlifyFunctionURL);

        const { formatted_address } = response.data.results[0];
        this.existingPlace = response.data.results[0];
        console.log(`Current location is ${formatted_address}`);
      } catch (error) {
        // Handle errors (geolocation errors, network errors, etc.)
        console.error('Error getting geolocation:', error);
      }
    },

    async getNomadCount() {

      console.log('checking nomad count')
      const { data, error } = await supabase
          .from('locations')
          // .select('*', { count: 'exact', head: true })
          .select('nomad_count')
          .eq('id', this.existingPlace.place_id);
      if (error) {
        console.error('Error checking row existence:', error);
      }
      if (data.length === 0) {
        console.log('location does not exist')
        this.locationNomadCount = 0
      } else {
        this.locationNomadCount = data[0]['nomad_count']
      }
      this.e1 = 2
    },

    initMarker(loc) {
      this.existingPlace = loc;
    },
    async addStay() {
      if (!this.arrivalDate || !this.existingPlace) {
        this.missingDataAlert = true
        return
      }
      this.stayDates = [this.arrivalDate, this.departureDate]
      store.commit('closeOnboardingDialog')
      this.missingDataAlert = false
      store.commit("loadingOn")
      let addLocationSuccess = await this.addLocationMarker()
      if (addLocationSuccess) {
        await store.dispatch("getTopLocations")
        await store.dispatch("getMyLocations")
        await store.dispatch("getUserData")
        store.commit('handleAddedLocationDialog', this.existingPlace.name || this.existingPlace?.formatted_address)
        this.existingPlace = null;
      }
      store.commit("loadingOff")
    }
  }
}

</script>

<style>


.onboardingDialogCard {
  padding-top: 0px;
  margin-bottom: 40px;
  text-align-last: center;
}

.onboardingDialogSubtitle {
  padding: 0;
}

.onboardingBtn {
  margin: 12px;
}
.placeAutoComplete{
  background-color: #e7eff8;
  border-radius: 15px!important;
}
</style>
